define('views/modules/calendar/animated-session/animation/lists/animation-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/i18n',
    // events
    'services/events/animated-session-events',
    // views
    'views/parts/menu/menu',
    'views/parts/menu/menu-context',
    // models
    'models/calendar/session/renamed-animation',
    'models/calendar/session/animation',
    // modals
    'views/modules/calendar/animated-session/animation/modal/delete-custom-exercise-modal',
    // templates
    'text!templates/modules/calendar/animated-session/animation/lists/animation-list-item.html',

], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    i18n,
    // events
    AnimationEvents,
    // views
    VMenu,
    VMenuContext,
    // models
    MRenamedAnimation,
    MAnimation,
    // modals
    VDeleteCustomExerciseModal,
    // templates
    TExerciseAnimationItem
) {

    var VExerciseAnimationItem = Backbone.Epoxy.View.extend({
        template: TExerciseAnimationItem,
        events: {
            "click .animation-box": "onClick",
            "click .options-toggle": "onMenuOptionToggle",
            "animation:drag": "onDrag",
        },

        regions: {
            item: ".animation-box",
            menu: ".menu-options",
            confirm: ".menu-confirm",
            thumbnail: ".exercise-thumbnail"
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                options: opt,
                view: {}
            });

            this.listenTo(this.model, {
                'remove': this.remove,
                'change:animationUrl': this.addTimestampToThumbnail,
                'animation:revertback': this.onRevertBackAction,
                'delete:confirmed': this.deleteCustomExercise
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.model.toJSON())));
            // Old line with drag and drop buggy
            // this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.model.toJSON())));
            var tooltipPlacement = this.getTooltipPlacement();

            this.$('span.sl-icon-pencil').tooltip({ placement: tooltipPlacement });

            this.generateZones()
                .applyBindings();

            this.addTimestampToThumbnail();

            return this;
        },

        getTooltipPlacement: function() {
            return this.model.get('columnIndex') % 2 === 0 ? 'right' : 'top';
        },

        setActive: function(val) {
            this.zone.$item.toggleClass('active', val);
        },

        isActive: function() {
            return this.zone.$item.hasClass('active');
        },

        setDisabled: function(val) {
            this.zone.$item.toggleClass('disabled', val);
        },

        isCustom: function() {
            return this.options.custom;
        },

        isManager: function() {
            return this.options.manager;
        },

        deleteCustomExercise: function() {
            this.model.destroy({
                context: this,
                wait: true,
                error: function(model, response) {
                    if (response.responseJSON) {
                        if (response.responseJSON.code === "EXERCISE_CHANGE_DENIED") {
                            Bootbox.alert({
                                title: i18n.t("Delete custom exercise"),
                                message: i18n.t("api-messages:EXERCISE_CHANGE_DENIED"),
                                onEscape: true,
                                backdrop: true,
                                context: this,
                            });
                        } else {
                            U.warn(response.responseJSON.message);
                        }
                    }
                }
            });
        },

        addTimestampToThumbnail: function() {
            this.zone.$thumbnail.attr('src', this.model.get('thumbnail') + '?' + new Date().getTime());
        },

        revertBackAnimationName: function() {
            var self = this;
            var renamed_animation = new MRenamedAnimation({ _id: this.model.get('_id') });
            renamed_animation.destroy().done(function() {
                self.fetchOriginalExercise();
            });
        },

         fetchOriginalExercise: function() {
            var newModel = new MAnimation({ _id: this.model.get('_id') }),
                self = this;

            newModel.fetch().done(function() {
                self.model.trigger('animation:reverted', newModel);
            });
        },

        isNotFromSettingsPanel: function() {
            return !this.options.manager;
        },

        /////////////
        // actions //
        /////////////

        onDetailAction: function() {
            this.model.trigger("animation:detail", this.model);
        },

        onRenameAction: function() {
            this.model.trigger("animation:rename", this.model);
        },

        onEditAction: function() {
            if (this.isNotFromSettingsPanel()) {
                this.model.trigger("animation:edit", this.model);
                return;
            }
            this.model.trigger('animation:click', this.model, false);
        },

        ////////////
        // events //
        ////////////

        onClick: function(e) {
            e.preventDefault();
            if (!this.$(e.target).hasClass('options-toggle') && !this.model.isDisabled()) {
                if (!this.isManager()) this.setActive();
                this.model.trigger('animation:click', this.model, this.isActive());
            }
        },

        onMenuOptionToggle: function(e) {
            e.preventDefault();
            var view = this.view.menu;

            if (!view) {
                var menuCollection = new Backbone.Collection([
                    { caption: 'View details', icon: "sl-icon-list", callback: this.onDetailAction },
                ]);

                if (this.isCustom()) {
                    menuCollection.add({ caption: 'Edit', icon: "sl-icon-pencil", callback: this.onEditAction });
                } else {
                    menuCollection.add({ caption: 'Rename', icon: "sl-icon-pencil", callback: this.onRenameAction });
                }

                if (this.isCustom()) {
                    menuCollection.add([
                        { caption: 'Delete', icon: "sl-icon-trash", callback: this.onShowDeleteModal }
                    ]);
                }

                view = this.view.menu = new VMenuContext({
                    collection: menuCollection,
                    context: this
                });

                this.listenTo(menuCollection, "item:click", this.onActionClick);
                this.assign(view, this.zone.$menu);
            }
            this.view.menu.toggle();
        },

        onShowDeleteModal: function() {
            (new VDeleteCustomExerciseModal({ model: this.model })).render();
        },

        onRevertBackAction: function() {
          Bootbox.confirm({
              title: i18n.t("exercise-revert-back"),
              message: i18n.t("messages:revert-back-message"),
              onEscape: true,
              backdrop: true,
              callback: function(accepted) {
                if (accepted) {
                    this.revertBackAnimationName();
                }
              },
              context: this,
          });
        },

        onDrag: function(e, dragEvt) {
            AnimationEvents.dragAnimation(this.model, dragEvt);
        },

        onActionClick: function(e, optionModel) {
            e.preventDefault();
            e.stopPropagation();
        },

    });

    return VExerciseAnimationItem;

});

